var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.98a6.642 6.642 0 1 0 0 13.283 6.642 6.642 0 0 0 0-13.284ZM7.358 10.62a8.642 8.642 0 1 1 17.284 0 8.642 8.642 0 0 1-17.284 0ZM1.994 28.387a7.4 7.4 0 0 1 7.4-7.4h13.212a7.4 7.4 0 0 1 7.4 7.4v.625a1 1 0 1 1-2 0v-.625a5.4 5.4 0 0 0-5.4-5.4H9.394a5.4 5.4 0 0 0-5.4 5.4v.625a1 1 0 1 1-2 0v-.625Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.1b42cbaf177700e56b9d71e6f7b850a1.svg";